export const CyCarousel = {
  LyricsItem: "LyricsItem",
  NextItem: "NextItem",
  PreviousItem: "PreviousItem",
  NextPageButton: "NextPageButton",
  PreviousPageButton: "PreviousPageButton",
  PlaylistSidebarButton: "PlaylistSidebarButton",
  PlaylistLivePositionSidebarButton: "PlaylistLivePositionSidebarButton",
  SendEmptyScreenCommandButton: "SendEmptyScreenCommandButton",
  PreviousLyricsPartButton: "PreviousLyricsPartButton",
  NextLyricsPartButton: "NextLyricsPartButton",
  MaximizeBeamerButton: "MaximizeBeamerButton",
  SettingsSidebarButton: "SettingsSidebarButton",
  ShareSidebarButton: "ShareSidebarButton",
  SongsheetsModeButton: "SongsheetsModeButton",
  LyricsModeButton: "LyricsModeButton",
  IncreaseFontButton: "IncreaseFontButton",
  DecreaseFontButton: "DecreaseFontButton",
} as const;
